// src/components/CartSideWidget.js
import React from 'react';
import { Link } from 'react-router-dom';

const CartSideWidget = ({ isOpen, toggleCartWidget, cart, updateQuantity, removeFromCart, cartTotal, formatPrice }) => {
  if (!isOpen) return null;

  return (
    <>
      <div className="wd-close-side wd-fill" onClick={toggleCartWidget}></div>
      <div className={`cart-widget-side wd-side-hidden wd-right ${isOpen ? 'wd-opened' : ''}`}>
        <div className="wd-heading">
          <span className="title">Shopping cart</span>
          <div className="close-side-widget wd-action-btn wd-style-text wd-cross-icon">
            <a href="#" rel="nofollow" onClick={(e) => { e.preventDefault(); toggleCartWidget(); }}>Close</a>
          </div>
        </div>
        <div className="widget woocommerce widget_shopping_cart">
          <div className="widget_shopping_cart_content">
            {cart.length === 0 ? (
              <p className="woocommerce-mini-cart__empty-message">No products in the cart.</p>
            ) : (
              <>
                <ul className="woocommerce-mini-cart cart_list product_list_widget ">
                  {cart.map((item, index) => (
                    <li key={item.productId || index} className="woocommerce-mini-cart-item mini_cart_item">
                      <a href="#" className="remove remove_from_cart_button" aria-label="Remove this item" onClick={(e) => { e.preventDefault(); removeFromCart(item.productId); }}>×</a>
                      <a href={item.link || '#'}>
                        {/* You might want to add an image here if available */}
                        {/* <img width="300" height="300" src={item.imageUrl || "/images/placeholder.png"} className="attachment-woocommerce_thumbnail size-woocommerce_thumbnail" alt=""/> */}
                        {item.title}
                      </a>
                      <span className="quantity">{item.quantity} × <span className="woocommerce-Price-amount amount"><bdi><span className="woocommerce-Price-currencySymbol">₹</span>{formatPrice(item.price)}</bdi></span></span>
                    </li>
                  ))}
                </ul>
                <p className="woocommerce-mini-cart__total total">
                  <strong>Subtotal:</strong> <span className="woocommerce-Price-amount amount"><bdi><span className="woocommerce-Price-currencySymbol">₹</span>{cartTotal}</bdi></span>
                </p>
                <p className="woocommerce-mini-cart__buttons buttons">
                  {/* These buttons would link to actual cart/checkout pages in a full app */}
                  <Link to="/cart_checkout" className="button wc-forward responsive-btn" style={{margin: '2px'}}>View cart</Link>
                  <Link to="/cart_checkout" className="button checkout wc-forward responsive-btn" style={{margin: '2px'}}>Checkout</Link>
                </p>
              </>
            )}
          </div>
        </div>
        
      </div>
    </>
  );
};

export default CartSideWidget;